import { matchRoutes } from 'react-router-dom';

const routes = [{ path: '/group-feed/:groupId' }, { path: '/feed/:postId' }];

/**
 * Find what params and route we have to the specified list.
 */
const getMatchedRoute = (location) => {
  const matched = matchRoutes(routes, location);
  return matched ? matched[0] : null;
};

export function parsePath(state) {
  const { location } = state.router;
  const match = getMatchedRoute(location);
  const queryParams = new URLSearchParams(state.router.location.search);  

  return {
    params: match ? match.params : {},
    queryParams: queryParams,
  };
}

export function getFeedPagination(state) {
  return {
    currentPage: state.feed.currentPage,
    totalPages: state.feed.totalPages,
  };
}

export function getKnowledgebasePagination(state) {
  return {
    currentPage: state.knowledgebase.currentPage,
    totalPages: state.knowledgebase.totalPages,
  };
}
